import { render, staticRenderFns } from "./InsolvencyPetitionTaskQueue.vue?vue&type=template&id=080a0bd3&scoped=true&"
import script from "./InsolvencyPetitionTaskQueue.vue?vue&type=script&lang=js&"
export * from "./InsolvencyPetitionTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyPetitionTaskQueue.vue?vue&type=style&index=0&id=080a0bd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a0bd3",
  null
  
)

export default component.exports